// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ng-valid[required], .ng-valid.required  {
  border: 1px solid #3c763d; 
}
.ng-touched.ng-invalid:not(form)  {
  border:1px solid #a94442; 
}
.report-tab-content .form-group {
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.text-danger{
  position: absolute;
  width: 94%;
}
.text-center{
  text-align: center !important;
}
#mySetting .modal-body{
  max-height: 350px;
  overflow-y: scroll;
}

.hidden{
  display:none;
}

.hidden-scenario{
  display:none;
}

.numberCircle { 

border-radius:50%;
width:20px;
height:20px;
display:block;
float:center;
border:2px solid #000000;
color:#000000;
text-align:center;
margin-right:5px;
}

.color-2{
  color:#00a6c6 !important;
}

.color-3{
  color:pink !important;
}
.status-block{
  margin-top: 30px;
  
  position: relative;
  align-items: baseline;
  align-items: end;
  justify-content: space-between;
  display: flex;
}
.status-block .status-text{
    position: relative;
    float: left;display: flex;
    align-items: baseline
}
.status-bar{padding: 18px 0}
.edit.glyphicon {
  background: #00a6c6;
  padding: 3px 0 0 5px;
  color: #fff;
  border-radius: 50%;
  height: 25px;
  font-size: 12px;
  width: 25px;
  cursor: pointer;
}
.glyphicon.pdficon {
  background: #00a6c6;
 
  color: #fff;
  border-radius: 50%;
  height: 25px;
  font-size: 12px;
  width: 25px;
  cursor: pointer;   
}
.title-form .form-group {

}
.btn-2{
background: #D60A49 !important;
}
.report-action-btn span{
  background: transparent;
  padding: 5px;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;
}

.sn_dec {width: 100%}
.glyphicon-pencil{margin: 0 7px; background: #00a6c6;
  padding: 5px;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;}
.pagination>li>a, .pagination>li>span { border-radius: 50% !important;margin: 0 5px;}
.pagination{margin: 0px}
.btn-sm-rounded{    vertical-align: top;
  margin-top: 6px;}
  .modal-body {
    position: relative;
    padding: 6px 16px;
}
#generateReportModal .modal-body {
  position: relative;
  padding: 6px 16px;
  height: 490px;
  overflow-y: scroll;
}
.modal-content .text-center{    margin: 15px 0;}
.plan-a{float: left;width: 100%;}
.clr_bg{background: #fff;}
#btncompleted{    width: 160px;}
.accordion-report{float: left;width: 100%;}
.accordion-report .panel-title {

  font-size: 16px;
  color: inherit;
  display: inline;
  background: #0075bc !important;
  padding: 4px 21px;
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
}

.panel-title{
  font-size: 16px;
  color: inherit;
  display: inline;
  background: #0075bc !important;
  padding: 4px 21px;
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  padding-left: 34px;
}
.planhead {
  float: left;
  background: #00a6c6;
  padding: 10px 30px;
  color: #fff;
  margin: 0 -15px;
  width: 102.6%;
}




.panel-title > a:before {
    float: left !important;
    font-family: FontAwesome;
    content:"\\f068";
    padding-right: 5px;
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a.collapsed:before {
    float: left !important;
    content:"\\f067";
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a:hover, 
.panel-title > a:active, 
.panel-title > a:focus  {
    text-decoration:none;
}
.panel-body {
  padding: 15px 40px;
}
.left-block{float: left}
.right-block{float: right}
.panel{border:none;}
.accord-block{float: left;width: 100%;    margin-bottom: 15px;}
.accord-block:last-child{    margin-bottom: 0;}
.panel-group {
 
  background: #fff;
}
.rdesc{padding-top: 0;margin-top: -2px}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}

.bus-name .btn-primary {
border-color: #949599;
position: relative;
top: 26px;
    background-color: #fff;
    left: -11px;
}
.bg-white .glyphicon {

color: #949599;
}
.client-name {
  color: #d6104c;
  font-weight: bold;
  width: 135px;
  float: right;
}
.client-name span {
  float: left;
  font-size: 13px;
  width: 100%;
  font-weight: normal;
  color: #949599;
}
.btn-gray {
  background-color: #999!important;
}
.scenario-btn-gray {
  background-color: #999!important;
}
.btn-orange {
  background-color: #FF4500!important;
}
.edit1{top:7px;}
.btn-marign{margin-bottom: 10px}
#accordion_new b{    color: #00a6c6;}
#accordion_new  .row{    margin-bottom: 7px;}
.panel-body td, .panel-body th {

  border: 1px solid #ccc;
  padding: 6px 22px;text-align: left !important;    width: 56%;
}
.blue-head{    color: #00a6c6;}
.left-block input[type=checkbox]  {
  margin: 4px 6px 0;
  margin-top: 1px\\9;
  line-height: normal;
  top: 2px;
  position: relative;
}

.planAmodal{float: left;width: 100%;}

.report-action-btn {
  background: #509fcc;
  width: auto;
  height: 28px;
  border-radius: 15px;
  text-align: center;
  float: left;
  margin-left: 18px;
}

.draft{
  color:#9A0A35;
}
.bluecomplete {
  color: #00a6c6;
  
}

.btn-orange {
  background-color: #F36324;
}


.nopadding{padding: 0}
.norightpadding{padding-right: 0}
.noleftpadding{padding-right: 0}

.another-col{width: 46% !important;}

@media (max-width:1024px) and (min-width:768px) {



  .padtop{    margin-top: -16px;
    padding-top: 0;}

    .new-input {
      display: block;
      justify-content: space-around;
      align-items: center;margin-left: 20px;
  }
  .new-input label {

    float: left;
    text-align: left;
    width: 23%;
}
.new-input label:nth-of-type(5){margin-left: 0;}

.status-block {
  margin-top: 38px;
}
}

`, "",{"version":3,"sources":["webpack://./src/app/report-list/report-list.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;AAEA,iBAAiB;AACjB,UAAU;AACV,WAAW;AACX,aAAa;AACb,YAAY;AACZ,wBAAwB;AACxB,aAAa;AACb,iBAAiB;AACjB,gBAAgB;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;AACA;IACI,kBAAkB;IAClB,WAAW,CAAC,aAAa;IACzB;AACJ;AACA,YAAY,eAAe;AAC3B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;;EAEnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;;AAEA;AACA;AACA,8BAA8B;AAC9B;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,SAAS,WAAW;AACpB,kBAAkB,aAAa,EAAE,mBAAmB;EAClD,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe,CAAC;AAClB,wCAAwC,6BAA6B,CAAC,aAAa,CAAC;AACpF,YAAY,WAAW;AACvB,oBAAoB,mBAAmB;EACrC,eAAe,CAAC;EAChB;IACE,kBAAkB;IAClB,iBAAiB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;AACA,gCAAgC,cAAc,CAAC;AAC/C,QAAQ,WAAW,CAAC,WAAW,CAAC;AAChC,QAAQ,gBAAgB,CAAC;AACzB,kBAAkB,YAAY,CAAC;AAC/B,kBAAkB,WAAW,CAAC,WAAW,CAAC;AAC1C;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;;;;AAKA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;;;IAGI,oBAAoB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA,YAAY,WAAW;AACvB,aAAa,YAAY;AACzB,OAAO,WAAW,CAAC;AACnB,cAAc,WAAW,CAAC,WAAW,KAAK,mBAAmB,CAAC;AAC9D,6BAA6B,gBAAgB,CAAC;AAC9C;;EAEE,gBAAgB;AAClB;AACA,OAAO,cAAc,CAAC,gBAAgB;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;AACA,qBAAqB;AACrB,kBAAkB;AAClB,SAAS;IACL,sBAAsB;IACtB,WAAW;AACf;AACA;;AAEA,cAAc;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mCAAmC;AACrC;AACA,OAAO,OAAO,CAAC;AACf,YAAY,mBAAmB;AAC/B,qBAAqB,cAAc,CAAC;AACpC,yBAAyB,kBAAkB,CAAC;AAC5C;;EAEE,sBAAsB;EACtB,iBAAiB,CAAC,2BAA2B,KAAK,UAAU;AAC9D;AACA,eAAe,cAAc,CAAC;AAC9B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,YAAY,WAAW,CAAC,WAAW,CAAC;;AAEpC;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;;AAEhB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,WAAW,UAAU;AACrB,gBAAgB,gBAAgB;AAChC,eAAe,gBAAgB;;AAE/B,aAAa,qBAAqB,CAAC;;AAEnC;;;;EAIE,YAAY,iBAAiB;IAC3B,cAAc,CAAC;;IAEf;MACE,cAAc;MACd,6BAA6B;MAC7B,mBAAmB,CAAC,iBAAiB;EACzC;EACA;;IAEE,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;AACA,gCAAgC,cAAc,CAAC;;AAE/C;EACE,gBAAgB;AAClB;AACA","sourcesContent":[".ng-valid[required], .ng-valid.required  {\r\n  border: 1px solid #3c763d; \r\n}\r\n.ng-touched.ng-invalid:not(form)  {\r\n  border:1px solid #a94442; \r\n}\r\n.report-tab-content .form-group {\r\n  padding-bottom: 25px;\r\n  margin-bottom: 0px;\r\n}\r\n.text-danger{\r\n  position: absolute;\r\n  width: 94%;\r\n}\r\n.text-center{\r\n  text-align: center !important;\r\n}\r\n#mySetting .modal-body{\r\n  max-height: 350px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.hidden{\r\n  display:none;\r\n}\r\n\r\n.hidden-scenario{\r\n  display:none;\r\n}\r\n\r\n.numberCircle { \r\n\r\nborder-radius:50%;\r\nwidth:20px;\r\nheight:20px;\r\ndisplay:block;\r\nfloat:center;\r\nborder:2px solid #000000;\r\ncolor:#000000;\r\ntext-align:center;\r\nmargin-right:5px;\r\n}\r\n\r\n.color-2{\r\n  color:#00a6c6 !important;\r\n}\r\n\r\n.color-3{\r\n  color:pink !important;\r\n}\r\n.status-block{\r\n  margin-top: 30px;\r\n  \r\n  position: relative;\r\n  align-items: baseline;\r\n  align-items: end;\r\n  justify-content: space-between;\r\n  display: flex;\r\n}\r\n.status-block .status-text{\r\n    position: relative;\r\n    float: left;display: flex;\r\n    align-items: baseline\r\n}\r\n.status-bar{padding: 18px 0}\r\n.edit.glyphicon {\r\n  background: #00a6c6;\r\n  padding: 3px 0 0 5px;\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  height: 25px;\r\n  font-size: 12px;\r\n  width: 25px;\r\n  cursor: pointer;\r\n}\r\n.glyphicon.pdficon {\r\n  background: #00a6c6;\r\n \r\n  color: #fff;\r\n  border-radius: 50%;\r\n  height: 25px;\r\n  font-size: 12px;\r\n  width: 25px;\r\n  cursor: pointer;   \r\n}\r\n.title-form .form-group {\r\n\r\n}\r\n.btn-2{\r\nbackground: #D60A49 !important;\r\n}\r\n.report-action-btn span{\r\n  background: transparent;\r\n  padding: 5px;\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.sn_dec {width: 100%}\r\n.glyphicon-pencil{margin: 0 7px; background: #00a6c6;\r\n  padding: 5px;\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  font-size: 12px;\r\n  cursor: pointer;}\r\n.pagination>li>a, .pagination>li>span { border-radius: 50% !important;margin: 0 5px;}\r\n.pagination{margin: 0px}\r\n.btn-sm-rounded{    vertical-align: top;\r\n  margin-top: 6px;}\r\n  .modal-body {\r\n    position: relative;\r\n    padding: 6px 16px;\r\n}\r\n#generateReportModal .modal-body {\r\n  position: relative;\r\n  padding: 6px 16px;\r\n  height: 490px;\r\n  overflow-y: scroll;\r\n}\r\n.modal-content .text-center{    margin: 15px 0;}\r\n.plan-a{float: left;width: 100%;}\r\n.clr_bg{background: #fff;}\r\n#btncompleted{    width: 160px;}\r\n.accordion-report{float: left;width: 100%;}\r\n.accordion-report .panel-title {\r\n\r\n  font-size: 16px;\r\n  color: inherit;\r\n  display: inline;\r\n  background: #0075bc !important;\r\n  padding: 4px 21px;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n}\r\n\r\n.panel-title{\r\n  font-size: 16px;\r\n  color: inherit;\r\n  display: inline;\r\n  background: #0075bc !important;\r\n  padding: 4px 21px;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n  padding-left: 34px;\r\n}\r\n.planhead {\r\n  float: left;\r\n  background: #00a6c6;\r\n  padding: 10px 30px;\r\n  color: #fff;\r\n  margin: 0 -15px;\r\n  width: 102.6%;\r\n}\r\n\r\n\r\n\r\n\r\n.panel-title > a:before {\r\n    float: left !important;\r\n    font-family: FontAwesome;\r\n    content:\"\\f068\";\r\n    padding-right: 5px;\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a.collapsed:before {\r\n    float: left !important;\r\n    content:\"\\f067\";\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a:hover, \r\n.panel-title > a:active, \r\n.panel-title > a:focus  {\r\n    text-decoration:none;\r\n}\r\n.panel-body {\r\n  padding: 15px 40px;\r\n}\r\n.left-block{float: left}\r\n.right-block{float: right}\r\n.panel{border:none;}\r\n.accord-block{float: left;width: 100%;    margin-bottom: 15px;}\r\n.accord-block:last-child{    margin-bottom: 0;}\r\n.panel-group {\r\n \r\n  background: #fff;\r\n}\r\n.rdesc{padding-top: 0;margin-top: -2px}\r\n.btn-circle {\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 6px 0;\r\n  font-size: 12px;\r\n  line-height: 1.428571429;\r\n  border-radius: 15px;\r\n}\r\n\r\n.bus-name .btn-primary {\r\nborder-color: #949599;\r\nposition: relative;\r\ntop: 26px;\r\n    background-color: #fff;\r\n    left: -11px;\r\n}\r\n.bg-white .glyphicon {\r\n\r\ncolor: #949599;\r\n}\r\n.client-name {\r\n  color: #d6104c;\r\n  font-weight: bold;\r\n  width: 135px;\r\n  float: right;\r\n}\r\n.client-name span {\r\n  float: left;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  font-weight: normal;\r\n  color: #949599;\r\n}\r\n.btn-gray {\r\n  background-color: #999!important;\r\n}\r\n.scenario-btn-gray {\r\n  background-color: #999!important;\r\n}\r\n.btn-orange {\r\n  background-color: #FF4500!important;\r\n}\r\n.edit1{top:7px;}\r\n.btn-marign{margin-bottom: 10px}\r\n#accordion_new b{    color: #00a6c6;}\r\n#accordion_new  .row{    margin-bottom: 7px;}\r\n.panel-body td, .panel-body th {\r\n\r\n  border: 1px solid #ccc;\r\n  padding: 6px 22px;text-align: left !important;    width: 56%;\r\n}\r\n.blue-head{    color: #00a6c6;}\r\n.left-block input[type=checkbox]  {\r\n  margin: 4px 6px 0;\r\n  margin-top: 1px\\9;\r\n  line-height: normal;\r\n  top: 2px;\r\n  position: relative;\r\n}\r\n\r\n.planAmodal{float: left;width: 100%;}\r\n\r\n.report-action-btn {\r\n  background: #509fcc;\r\n  width: auto;\r\n  height: 28px;\r\n  border-radius: 15px;\r\n  text-align: center;\r\n  float: left;\r\n  margin-left: 18px;\r\n}\r\n\r\n.draft{\r\n  color:#9A0A35;\r\n}\r\n.bluecomplete {\r\n  color: #00a6c6;\r\n  \r\n}\r\n\r\n.btn-orange {\r\n  background-color: #F36324;\r\n}\r\n\r\n\r\n.nopadding{padding: 0}\r\n.norightpadding{padding-right: 0}\r\n.noleftpadding{padding-right: 0}\r\n\r\n.another-col{width: 46% !important;}\r\n\r\n@media (max-width:1024px) and (min-width:768px) {\r\n\r\n\r\n\r\n  .padtop{    margin-top: -16px;\r\n    padding-top: 0;}\r\n\r\n    .new-input {\r\n      display: block;\r\n      justify-content: space-around;\r\n      align-items: center;margin-left: 20px;\r\n  }\r\n  .new-input label {\r\n\r\n    float: left;\r\n    text-align: left;\r\n    width: 23%;\r\n}\r\n.new-input label:nth-of-type(5){margin-left: 0;}\r\n\r\n.status-block {\r\n  margin-top: 38px;\r\n}\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
